import { IAppState } from '../../common/state';
import { IUnderground } from '../../types/newbuildingHeader';

export function getUnderground({ newbuildingInformation }: IAppState): IUnderground | null {
  return newbuildingInformation?.underground || null;
}
